import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AppConfig {
    settings: IAppConfig;
    constructor(private http: HttpClient) { }
    load(): Observable<IAppConfig> {
        const jsonFile = `assets/config/appconfig.json`;
        return this.http.get(jsonFile).pipe(tap((response: IAppConfig) => {
            this.settings = response;
        }))
    };
}

export interface IAppConfig {
    ccaName: string,
    defaultURL: string,
    appInsightsKey: string,
}
